import { PlayerEnvironment } from '../player_environment';
import LocalStorageAdapter from '../adapters/localstorage_adapter';

export default class VolumeStateService {
  shouldInit() {
    return this.data().embed() === 'false' && PlayerEnvironment.isMobileSite() === false;
  }

  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._volumeStorageName = 'playback_volume_state';
    this._muteStorageName = 'playback_mute_state';
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  volumeStorageName() {
    return this._volumeStorageName;
  }

  muteStorageName() {
    return this._muteStorageName;
  }

  isNotSafari() {
    return !['Safari', 'Mobile Safari'].includes(PlayerEnvironment.browserName());
  }

  init() {
    this.bindLoadstart();
    this.bindWindowUnload();
  }

  bindLoadstart() {
    this.tech().on('loadstart', () => {
      this.setVolumeFromLocalStorage();

      if (this.isNotSafari()) {
        this.setMuteFromLocalStorage();
      }
    });
  }

  setVolumeFromLocalStorage() {
    const volume = LocalStorageAdapter.getItem(this.volumeStorageName());

    if (volume !== null && volume !== undefined) {
      this.tech().volume(Number(volume));
    }
  }

  setMuteFromLocalStorage() {
    const mute = LocalStorageAdapter.getItem(this.muteStorageName());

    if (mute !== null && mute !== undefined) {
      const muteState = (mute === "true");
      this.tech().muted(muteState);
    }
  }

  bindWindowUnload() {
    const eventName = PlayerEnvironment.browserName() === 'Mobile Safari' ? 'pagehide' : 'beforeunload';
    window.addEventListener(eventName, this.windowUnloadCallback.bind(this));
  }

  windowUnloadCallback() {
    this.storeVolumeState();

    if (this.isNotSafari()) {
      this.storeMuteState();
    }
  }

  storeVolumeState() {
    const volume = this.tech().volume();
    LocalStorageAdapter.setItem(this.volumeStorageName(), JSON.stringify(volume));
  }

  storeMuteState() {
    const mute = this.tech().muted();
    LocalStorageAdapter.setItem(this.muteStorageName(), JSON.stringify(mute));
  }
}
